import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Card,Avatar } from 'antd';


const SuccessPage = (props) => {
    return (
        <Card className='gx-card'>
            <Row>
                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: "center" }} >
                    <img src="/favicon-96x96.png" ></img>
                </Col>
                {/* <Col lg={12} md={24} sm={24} xs={24} style={{ textAlign: "center" }}>
                    <Avatar size={64} src="/hp.png" />
                </Col> */}

                <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: "center" }} >
                    <h1 style={{ color: "green" }}>Form Submitted Successfully !</h1>
                </Col>
            </Row>
        </Card>
    )
}

export default SuccessPage;